import { resolve } from 'url'
import * as jwtUtils from '../util/jwt_utils'
import * as randomUtils from '../util/random_utils'
import { compose, interpretErrors, formatQueryParams } from '../util/api_utils'

export const requestIDPrefix = randomUtils.guid()

export const apiHost = process.env.REACT_APP_API_ENDPOINT

export {
    getEndpointRaw,
    postEndpointRaw,
    putEndpointRaw,
    patchEndpointRaw,
    deleteEndpointRaw,
    onResponse,
    handleErrorResp,
}

// HTTP verbs

function getEndpointRaw(path) {
    return (pathParams, queryParams) => {
        const interpolatedPath = interpolatePath(path, pathParams)
        const url = resolve(apiHost, interpolatedPath)
        const withParams = url + formatQueryParams(queryParams)
        return fetch(withParams, {
            method: 'GET',
            headers: getHeaders(),
        })
    }
}

function postEndpointRaw(path) {
    return requestBody => {
        const interpolatedPath = interpolatePath(path, requestBody)
        const url = resolve(apiHost, interpolatedPath)
        return fetch(url, {
            method: 'POST',
            headers: getHeaders({'Content-Type': 'application/json; charset=UTF-8'}),
            body: JSON.stringify(requestBody),
        })
    }
}

function putEndpointRaw(path) {
    return (requestBody, pathParams) => {
        const interpolatedPath = interpolatePath(path, requestBody, pathParams)
        const url = resolve(apiHost, interpolatedPath)
        return fetch(url, {
            method: 'PUT',
            headers: getHeaders({'Content-Type': 'application/json; charset=UTF-8'}),
            body: JSON.stringify(requestBody),
        })
    }
}

function patchEndpointRaw(path) {
    return (requestBody, pathParams) => {
        const interpolatedPath = interpolatePath(path, requestBody, pathParams)
        const url = resolve(apiHost, interpolatedPath)
        return fetch(url, {
            method: 'PATCH',
            headers: getHeaders({'Content-Type': 'application/json; charset=UTF-8'}),
            body: JSON.stringify(requestBody),
        })
    }
}

function deleteEndpointRaw(path) {
    return requestBody => {
        const interpolatedPath = interpolatePath(path, requestBody)
        const url = resolve(apiHost, interpolatedPath)
        return fetch(url, {
            method: 'DELETE',
            headers: getHeaders({'Content-Type': 'application/json; charset=UTF-8'}),
        })
    }
}

// helpers

function interpolatePath(path, requestBody, pathParams) {
    return typeof(path) == "function" ? path(pathParams ? pathParams : requestBody) : path
}

export function getHeaders(otherHeaders = {}) {
    const token = jwtUtils.useTmpToken() || jwtUtils.getToken()
    const authHeaders = token ? {'Authorization': 'Bearer ' + token} : {}
    const requestId = requestIDPrefix + "|" + randomUtils.guid()
    const headers = Object.assign({}, otherHeaders, authHeaders, {'accept': 'application/json'}, {'Set-Request-Id' : requestId } )

    return headers
}

function onResponse(fn, endpoint) {
    return compose(promise => promise.then(resp => fn(resp)), endpoint)
}

function handleErrorResp(resp, unauthHandler = () => {}) {
    const status = resp.status
    if (status >= 400 && status < 500) {
        if (status === 401) {
            return unauthHandler(resp)
        }

        const json = resp.json().then(errors => interpretErrors(errors))
        return json.then(Promise.reject.bind(Promise))
    }
    else if (status >= 500) {
        return resp.text().then(Promise.reject.bind(Promise))
    }
    else {
        return Promise.resolve(resp)
    }
}


// WEBPACK FOOTER //
// ./src/api/api.js